module.exports = __webpack_public_path__ + "img/1alB-dz-dzul.17c434b9.jpg";